import { render } from "./DeductionsPagination.vue?vue&type=template&id=bc4bec72"
import script from "./DeductionsPagination.vue?vue&type=script&lang=js"
export * from "./DeductionsPagination.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__